// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

export var StatusSharedCssClassName = {
  STATUS_CONTAINER: 'statusView-content-wrap',
  STATUS_LOZENGE: 'status-lozenge-span'
};